import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PublicPrivateField from '@shared/forms/PublicPrivateField'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'
import { T } from '@transifex/react'
import { useFormContext } from 'react-hook-form'

const MobileRecognitionVisibilityView = () => {
  const { control } = useFormContext<RecognitionFormData>()

  return (
    <>
      <Paper sx={{ pb: 2, px: 2, width: '100%' }}>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Typography variant="body2" sx={{ pt: 2 }}>
            <T _str="Visibility" />
          </Typography>
          <Box>
            <PublicPrivateField name="tenantWide" control={control} />
          </Box>
        </Stack>
      </Paper>
      <Typography variant="caption" sx={{ pt: 1.5 }}>
        <T _str="When a post is set to private, it is visible only to the sender, recipient, and admins" />
      </Typography>
    </>
  )
}

export default MobileRecognitionVisibilityView
